module.exports = __webpack_public_path__ + "static/sandbox@2x-min-048c9833e71f1571e728344b58db1748.png";